import React, { useCallback } from "react";
import EventResults from "./EventResults";
import {
  AccountingEventsGroup,
  DigitalBusinessDocument,
  DigitalCostDocument,
} from "../../types";
import { getEventVersion } from "../../helpers/typeChecks";
import VersionSelector from "../common/VersionSelector";

interface Props {
  eventData: (
    | AccountingEventsGroup
    | DigitalBusinessDocument
    | DigitalCostDocument
  )[];
  onVersionChange: (index: number) => void;
}

export default function EventsVersionSelector(props: Props) {
  const { eventData, onVersionChange } = props;

  const handleVersionChange = useCallback(
    (index: number) => {
      onVersionChange(index);
    },
    [onVersionChange]
  );

  const renderTabContent = useCallback(
    (
      items: (
        | AccountingEventsGroup
        | DigitalBusinessDocument
        | DigitalCostDocument
      )[]
    ) => {
      return <EventResults eventData={items[0]} />;
    },
    []
  );

  const renderTabLabel = useCallback((version: number) => {
    return `Version ${version}`;
  }, []);

  return (
    <VersionSelector
      data={eventData}
      getVersion={getEventVersion}
      renderTabLabel={renderTabLabel}
      renderTabContent={renderTabContent}
      onVersionChange={handleVersionChange}
    />
  );
}
